import { createIntentType } from './intent';
export function createMapIntentType(label, create, getKey, merge) {
    function add(intent, state = new Map()) {
        const key = getKey(intent);
        if (merge) {
            const existing = state.get(key);
            if (typeof existing !== 'undefined') {
                const result = merge(existing, intent);
                if (typeof result !== 'undefined') {
                    state.set(key, result);
                }
                return state;
            }
        }
        state.set(key, intent);
        return state;
    }
    return createIntentType(label, {
        add,
        create,
        merge (target, source) {
            if (target) {
                source.forEach((intent)=>add(intent, target));
                return target;
            } else {
                return new Map(source);
            }
        }
    });
}

//# sourceMappingURL=createMapIntentType.js.map